import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f358306"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center cola-color font-Noto fw-bold tilte text-18 text-54" }, " 수거 신청 전 체크리스트 ", -1))
const _hoisted_2 = { class: "box-options mt-3 font-Pretendar" }
const _hoisted_3 = { class: "footer-btn-group" }
const _hoisted_4 = { class: "footer-btn-group" }
const _hoisted_5 = { class: "footer-btn-group" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cola-color font-Pretendar" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mt-5 fw-bold text-20 text-80" }, " 수거 신청 완료 "),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-3 text-14 text-54" }, [
    /*#__PURE__*/_createTextVNode(" 3-4일 이내에 한진택배 기사님이 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 방문하여 수거합니다. ")
  ]),
  /*#__PURE__*/_createElementVNode("h5", { class: "mt-5 text-42 text-10" }, [
    /*#__PURE__*/_createTextVNode(" 리워드는 보내주신 제로 웨이스트 박스 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 검수 후 순차적으로 발송됩니다. ")
  ])
], -1))

import EveryoneCollectStep1 from '@/templates/campaign-cocacola-season-6/components/everyone-collect-step1.vue';
import ParticipateSuccess from '@/templates/campaign-cocacola-season-6/components/participate-success.vue';
import { ref, reactive, computed, inject, type DeepReadonly, type Ref, nextTick } from 'vue';
import type { Challenge } from './model/challenge';
import Popup from '@/templates/campaign-cocacola-season-6/components/popups/popup.vue';
import Options from '@/templates/campaign-cocacola-season-6/components/popups/options.vue';
import { request } from '@/utils';
import _ from 'lodash';
import { IProgram } from '@/types/program';
import PopupError from '@/templates/campaign-cocacola-season-6/components/popups/popup-error.vue';
import ColaButton from '@/templates/campaign-cocacola-season-6/components/cola-button.vue';

interface Props {
  challenge: Challenge;
  type: 'participate' | 'collect';
}


export default /*#__PURE__*/_defineComponent({
  props: {
    challenge: null,
    type: null
  },
  setup(__props: any) {

const props = __props as {
  challenge: Challenge;
  type: 'participate' | 'collect';
}


const errMsg = ref('');
const popupVisible = reactive({
  step1: true,
  step2: false,
  step3: false,
  success: false,
  requestWaitingLists: false,
  operationSuccess: false,
  step1Error: false,
  error: false,
});
const step2Options = [
  '📦  박스 표시선까지 페트병을 채웠나요?',
  '📦  라벨 제거, 압착, 뚜껑을 닫아서 담았나요?',
  '📦  신청하는 박스 수량이 맞나요?',
  '📦  주소지가 올바르게 작성되어 있나요?'
];
const program = inject<DeepReadonly<Ref<IProgram>>>('program');
const refreshPageData = inject<Function>('refreshPageData') || _.noop;
const getDefaultStep2OptionSelected = () => [];
const step2OptionSelected = ref(getDefaultStep2OptionSelected());
const step2OptionAllChecked = computed(() => step2OptionSelected.value.length === step2Options.length);
const requestWaitingListsMessage = ref('');

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    _.forEach(popupVisible, (val, key) => {
      if (val) {
        popupVisible[key] = false;
      }
    });
  }
}

let number_bottle = 0;

const handleNext = (value) => {
  number_bottle = value.number_bottle;
  popupVisible.step2 = true;
};

const submit = () => {
  // Call API to submit the form
  onStep3Submit();
};

async function onStep3Submit() {
  try {
    await request.post('user_requests', {
      target_id: props.challenge.programId,
      target_type: 'Program',
      type: 'CollectionRequest',
      request_times: number_bottle
    }, {
      loading: { silent: true }
    });
    await refreshPageData();
    popupVisible.step1 = false;
    popupVisible.step2 = false;
    popupVisible.step3 = true;
  } catch (e) {
    const errorMsg = _.get(e, 'message');
    const code = _.get(e, 'code');
    const status = _.get(e, 'status');
    // 项目人次达到上限，需要显示错误信息并提示是否订阅 waiting list
    if (status !== 401 && String(code) === '40008') {
      requestWaitingListsMessage.value = errorMsg;
      await showPopup('requestWaitingLists');
      return;
    }
    // request.ts已经处理过这个code了
    if (String(code) !== '40305') {
      errMsg.value = errorMsg;
      popupVisible['error'] = true;
    }
    throw e;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(popupVisible).step1)
      ? (_openBlock(), _createBlock(EveryoneCollectStep1, {
          key: 0,
          onNext: handleNext
        }))
      : _createCommentVNode("", true),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step2,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(popupVisible).step2) = $event)),
      class: "collect-modal step-2"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ColaButton, {
            title: "확인했어요",
            "no-icon": true,
            border: true,
            responsive: true,
            disabled: !_unref(step2OptionAllChecked),
            onClick: submit
          }, null, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Options, {
            modelValue: step2OptionSelected.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((step2OptionSelected).value = $event)),
            options: step2Options
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).error,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(popupVisible).error) = $event)),
      title: errMsg.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (hidePopup(`error`)))
          }, " 확인했어요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).requestWaitingLists,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(popupVisible).requestWaitingLists) = $event)),
      title: requestWaitingListsMessage.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(popupVisible).requestWaitingLists = false))
          }, " 닫기 "),
          _createElementVNode("button", {
            class: "footer-btn primary",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.subscribeWaitingList && _ctx.subscribeWaitingList(...args)))
          }, " 신청할게요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    (_unref(popupVisible).step3)
      ? (_openBlock(), _createBlock(ParticipateSuccess, { key: 1 }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})